import { render, staticRenderFns } from "./Xendit.vue?vue&type=template&id=4b461846"
import script from "./Xendit.vue?vue&type=script&lang=js"
export * from "./Xendit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports